import { Badge, Switch } from "@mantine/core";
import "./NotificationToggles.scss";
import { clientStatuses } from "@/constants";

interface NotificationTogglesProps {
  settings: any;
  handleToggle: (category: string, key: string, value: boolean) => Promise<any>;
}

type ClientStatusKeys = keyof typeof clientStatuses;

const NotificationToggles = ({
  settings,
  handleToggle,
}: NotificationTogglesProps) => {
  const clientStatusKeys: ClientStatusKeys[] = Object.keys(
    clientStatuses
  ) as ClientStatusKeys[];

  return (
    <ul className="email-preferences">
      {clientStatusKeys.map((status) => (
        <li key={status} className="email-preference-item">
          <Badge
            className={`statusClass-${clientStatuses[status].class}`}
            size="xl"
          >
            {status}
          </Badge>
          <Switch
            size="md"
            checked={settings?.statuses.includes(status)}
            onChange={(event) =>
              handleToggle(
                "clientEmailNotifications",
                status,
                event.currentTarget.checked
              )
            }
          />
        </li>
      ))}
    </ul>
  );
};

export default NotificationToggles;
